// extracted by mini-css-extract-plugin
export var addinterested = "DogListingCard-module--addinterested--cf9b3";
export var dogbreedtext = "DogListingCard-module--dogbreedtext--00794";
export var dogcardcontainer = "DogListingCard-module--dogcardcontainer--11630";
export var dogcarddetails = "DogListingCard-module--dogcarddetails--a06d2";
export var dogcarddetailscontainer = "DogListingCard-module--dogcarddetailscontainer--833e5";
export var dogcardimage = "DogListingCard-module--dogcardimage--afffb";
export var dogcardimagewrapper = "DogListingCard-module--dogcardimagewrapper--c1420";
export var dogisreserved = "DogListingCard-module--dogisreserved--f242d";
export var dogisunderdog = "DogListingCard-module--dogisunderdog--20695";
export var dognametext = "DogListingCard-module--dognametext--be57e";
export var dogplaceholderimage = "DogListingCard-module--dogplaceholderimage--c84fa";
export var innercontainer = "DogListingCard-module--innercontainer--be405";
export var rehomingcentretext = "DogListingCard-module--rehomingcentretext--c6be8";